<div class="otpCode">
    @if (allowUserSwitching) {
        <p>
            <span [innerHTML]="'generalKeywords.otp.signingInWith' | translate: { email: email }"></span>
            <br />
            {{ 'generalKeywords.otp.wrongUser' | translate }}
            <button class="button linkLike" (click)="disableOtp()">{{ 'generalKeywords.otp.switchUser' | translate }}</button>.
        </p>
    }
    <p>{{ 'generalKeywords.otp.administratorRequires2FA' | translate }}</p>

    <div class="inputGroup" [formGroup]="form">
        <app-form-error [parentForm]="form" [controlPath]="'otp'" [controlLabel]="'generalKeywords.otp.label' | translate" />
        <input
            type="text"
            id="otp"
            autocomplete="off"
            formControlName="otp"
            maxlength="6"
            minlength="6"
            [placeholder]="'generalKeywords.otp.label' | translate"
        />
    </div>
</div>
<div class="buttonArea">
    @if (isTimerRunning) {
        <p>
            {{ 'generalKeywords.otp.didntGetEmail' | translate }}
            <app-timer #timer [timerDuration]="30000" (timerComplete)="isTimerRunning = false" />.
        </p>
    } @else {
        <button
            class="button default icon resendOtp"
            type="button"
            id="resendOtp"
            title="{{ 'generalKeywords.otp.resend' | translate }}"
            (click)="requestNewOtpCode()"
        >
            <i class="far fa-refresh"></i><span>{{ 'generalKeywords.otp.resend' | translate }}</span>
        </button>
    }

    <button
        class="button primary"
        type="submit"
        id="signInWithOtp"
        title="{{ 'generalKeywords.otp.signIn' | translate }}"
        (click)="loginWithOtp()"
    >
        {{ 'generalKeywords.otp.signIn' | translate }}
    </button>
</div>
